<template>
    <div class="block-editor google-drive-delete-file">
        <section>
            <div class="title">{{ $t('auto.googleDriveDeleteFileChannelId') }}</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googleDriveDeleteFileGoogleDriveKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveDeleteFileFileId') }}</div>
            <TiptapEditor placeholder="Google Drive File ID" :show-attributes="true" v-model="clone.fileId" automation-mode />
            <small>{{ $t('auto.googleDriveDeleteFileSilinecekDosyanNGoogleDriveIdsi') }}</small>
        </section>
        <section class="warning">
            <a-alert type="warning" show-icon>
                <template slot="message">
                    Bu işlem geri alınamaz! Dosya kalıcı olarak silinecektir.
                </template>
            </a-alert>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveDeleteFile",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                fileId: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-delete-file {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }

    .warning {
        margin-top: 10px;
    }
}
</style>
